import { api } from './client';
import type { CancelRequest, Order, Refund, RefundRequest } from '../types';

export interface OrderQuery {
  storeId?: number | null;
  from?: string;
  to?: string;
  q?: string;
}

export const ordersApi = {
  list: (query: OrderQuery = {}) =>
    api
      .get<Order[]>('/orders', {
        params: {
          storeId: query.storeId ?? undefined,
          from: query.from || undefined,
          to: query.to || undefined,
          q: query.q || undefined,
        },
      })
      .then((r) => r.data),

  // `id` is the bill number (the public identifier).
  get: (id: string) => api.get<Order>(`/orders/${id}`).then((r) => r.data),

  cancelled: (storeId?: number | null) =>
    api
      .get<Order[]>('/orders/cancelled', {
        params: storeId != null ? { storeId } : undefined,
      })
      .then((r) => r.data),

  cancel: (id: string, body: CancelRequest) =>
    api.post<Order>(`/orders/${id}/cancel`, body).then((r) => r.data),

  refund: (id: string, body: RefundRequest) =>
    api.post<Refund>(`/orders/${id}/refund`, body).then((r) => r.data),

  refunds: (storeId?: number | null) =>
    api
      .get<Refund[]>('/refunds', {
        params: storeId != null ? { storeId } : undefined,
      })
      .then((r) => r.data),
};
